/**
 * Application version string. Single source of truth across all apps.
 * Update this value when bumping the version.
 */
export const APP_VERSION = '1.0.0-alpha';
